import React from 'react';
import { Box } from '@material-ui/core';
import { FieldLabelText } from './UserRequestsStyles';

export const DetailsField: React.FC<{
  label: string;
  value?: React.ReactNode;
}> = ({ label, value }) => (
  <Box style={{ marginBottom: 16 }}>
    <FieldLabelText>{label}</FieldLabelText>
    <Box>{value ?? '-'}</Box>
  </Box>
);
